import React from 'react';
import Iframe from 'react-iframe'
import '../App.css';


const Footer = (props) => {
  return (
  <div>  
    <div className="contact" id="contact">
      <div className="mapGroup">
        <div className="map">
            <Iframe url="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3144.540945396623!2d-57.554581400000025!3d-37.98784109999999!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x9584d955de045773%3A0x9c414446cd6e51f1!2sDorrego+1023%2C+B7600CLU+Mar+del+Plata%2C+Buenos+Aires!5e0!3m2!1ses!2sar!4v1438206170718"
              width="100%"
              height="400px"
              position="relative"
              style={{border: '2px'}} 
              allowFullScreen
            />
        </div>
        <div className="tmap"><p className="lead">Visitanos, <b>Picada Club</b> está en la calle <b>Dorrego 1023</b> casi Av. Libertad (al lado del Banco Nación) y
        frente a la plaza Gral. Pueyrredón. </p>
          <p className="lead"> Hacé tu reserva o pedido a nuestro teléfono <b>475-8406</b>
          {props.delivery !== "0" && 
           <span> y te lo llevamos a tu domicilio dentro de nuestra zona de delivery.</span>
          }
          </p>
          <h4>Disfrutá del sabor de una Picada Club.</h4>
        </div>
      </div>  
      <hr />
      <div className="container">
        <div className="row">
          <div className="col-lg-12 text-center">
            <h2 className="section-heading">Contactenos</h2>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-12">
              <form name="sentMessage" id="contactForm" action="mailto:info@picadaclub.com.ar">
              <div className="row">
                <div className="col-md-6">
                  <div className="form-group">
                    <input type="text" className="form-control" placeholder="Su Nombre *" id="name" required />
                  </div>
                  <div className="form-group">
                    <input type="email" className="form-control" placeholder="Su E-mail *" id="email" required />
                  </div>
                  <div className="form-group">
                    <input type="tel" className="form-control" placeholder="Su telefono *" id="phone" required />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <textarea rows="6" className="form-control" placeholder="Su mensaje *" id="message" />
                  </div>
                </div>
                <div className="clearfix"></div>
                <div className="col-lg-12 text-center">
                  <div id="success"></div>
                  <button type="submit" className="btn btn-warning btn-lg boton">Enviar mensaje</button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <div className="pie">
      <div className="col-md-12 col-xs-12 text-center" >
        <h4>Dorrego 1023 - Mar del plata<br/>Argentina </h4>
      </div>
      <div className="brand text-right">
        <a href="https://lilab.com.ar" target="_blank">Diseñado por <b>Lilab</b></a>
      </div>
    </div>
  </div>    
  )
}


export default Footer;



/** WEBPACK FOOTER **
 ** ./src/containers/footer.js
 **/


/** WEBPACK FOOTER **
 ** ./src/containers/footer.js
 **/